import { Container } from "./covernavigation.components";

const CoverNavigationPanel: React.FC = () => {
  return <Container />;
};

export default CoverNavigationPanel;
